import React, { Component } from "react";
import classNames from "classnames";
import { isEmpty } from "lodash";
import PropTypes from "prop-types";
import {
  CompanyName,
  DataTable,
  LinkedTableRow
} from "MODULES/shared/components";
import { shortDateYY } from "LIB/formatters/date";
import { dollars } from "LIB/formatters/currency";
import { miniTable } from "MODULES/shared/decorators";
import api from "APP_ROOT/api";
import { withRouter } from "react-router";
import withSubscription from "MODULES/Subscription/withSubscription";
import { getConditionAbbrev } from "MODULES/RepairOrders/constants";
import { getFirstNameLastInitial } from "LIB/formatters/text";
import { Link } from "react-router-dom";
import { AsIsFlag } from "MODULES/IncomingQuotes/shared/AsIsFlag";

export class Table extends Component {
  static propTypes = {
    results: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.number.isRequired,
        created_at: PropTypes.string.isRequired,
        company: PropTypes.shape({ name: PropTypes.string }),
        buyer: PropTypes.shape({ full_name: PropTypes.string }),
        condition: PropTypes.string.isRequired,
        quantity: PropTypes.number.isRequired,
        cost: PropTypes.string
      })
    ).isRequired,
    loading: PropTypes.bool.isRequired
  };

  rowClasses = lineItem =>
    classNames({
      "text-muted":
        lineItem.cancelled ||
        (lineItem.shipped && lineItem.return_to_customer_without_repairing)
    });

  renderRow = (lineItem, i) => (
    <LinkedTableRow
      to={`/lots/${lineItem.lot.uuid}`}
      className={this.rowClasses(lineItem)}
      key={i}
    >
      <td>{i + 1}</td>
      <td>{shortDateYY(lineItem.created_at)}</td>
      <td className="text-nowrap">
        <CompanyName flattenedCompany={lineItem} truncateAt={18} />
      </td>
      <td>{getFirstNameLastInitial(lineItem.created_by.full_name)}</td>
      <td>
        {lineItem.serial_number === "Various" ||
        (!lineItem.serial_number &&
          !isEmpty(lineItem.expected_serial_number)) ? (
          lineItem.serial_number || lineItem.expected_serial_number
        ) : (
          <Link to={`/inventories/${lineItem.inventory_link_id}`}>
            {lineItem.serial_number}
          </Link>
        )}
      </td>
      <td className="text-left">
        {getConditionAbbrev(lineItem.condition)}
        <AsIsFlag lineItem={lineItem} className="m-l-5" />
      </td>
      <td className="text-center">{lineItem.quantity}</td>
      <td className="text-right">{dollars(lineItem.cost)}</td>
    </LinkedTableRow>
  );

  render() {
    const { loading, results } = this.props;
    return (
      <DataTable.Mini loading={loading} numbered>
        <DataTable.Head>
          <th />
          <th>Date</th>
          <th>Vendor</th>
          <th>Buyer</th>
          <th>SN</th>
          <th>CD</th>
          <th className="text-center">QTY</th>
          <th className="text-right">COST/UNIT</th>
        </DataTable.Head>
        <DataTable.Body>{results.map(this.renderRow)}</DataTable.Body>
      </DataTable.Mini>
    );
  }
}

const withResults = miniTable(({ match }, params) =>
  api.parts.lotLineItems.search(match.params.id, params)
);

export default withRouter(withResults(withSubscription("LotLineItem")(Table)));



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/LotLineItems/LineItemsTable.jsx